import { render, staticRenderFns } from "./RealisationStep3D.vue?vue&type=template&id=27dead40"
import script from "./RealisationStep3D.vue?vue&type=script&lang=js"
export * from "./RealisationStep3D.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports